































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class'
import { mapGetters } from 'vuex'

import { statusWebservice } from '../../../webservices/status' 
import { eventWebservice } from '../../../webservices/event' 
import { notificationWebservice } from '../../../webservices/notification' 

import { Event } from '../../../models/event'
import { Status } from '../../../models/status'

 interface validationError {
    message:boolean ,
    status:boolean ,
}

@Component({
    name:'Create',
    components: {
      
    },

    // Vuex bindings
      computed: mapGetters('status', [
        'status'
    ])
    
})

   export default class Create extends Vue {

       
    // Data
    public event: Event = {
        text:'',
        status: <Status>{},
        push:false,
    }
    
    protected disabled:boolean = false
    protected isModalActive:boolean = false
    protected validationError: validationError =  {
        message: false,
        status: false,
    }

    @Getter('status/status') status
    
    // Mounted is called initially
    mounted() {

    }

    togglePushEvent() {
        this.event.push = !this.event.push;
    }

    cancelAndHideModal() {
        this.isModalActive = false;
    }

    showModal() {
        if (this.validate() == true) {
            if (this.event.push) {
                 this.isModalActive = true;
            } else {
                this.store();
            }
        }
        
    }

    store() {
        let self = this;
        eventWebservice.store(this.event).then(function(response) {
            console.log(response.data)
            self.$store.commit('event/setNewestEvent', self.event)  
            
            // Send notification if push is enabled
            if(self.event.push) {
                notificationWebservice.send(self.event)
            }

            self.event.text = '';
            self.validationError.status = false;
            self.validationError.message = false;
            self.isModalActive = false
        })
    }

    validate() {
        if (this.event.text != '') {
            if (Object.keys(this.event.status).length !== 0 && this.event.status.constructor === Object) {
                return true;
            } else {
                this.validationError.status = true;
                return false;     
            }
        } else {
            this.validationError.message = true;
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/events/create/Create.vue